import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=f9407c16&scoped=true&"
import script from "./promotion.vue?vue&type=script&lang=js&"
export * from "./promotion.vue?vue&type=script&lang=js&"
import style0 from "./promotion.vue?vue&type=style&index=0&id=f9407c16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9407c16",
  null
  
)

export default component.exports